"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IBoundaryDefinitionWithIdSchema = exports.IBoundaryDefinitionWithIdSchema_ConnectionDefinition = exports.IBoundaryDefinitionWithIdSchema_NumericalDefinition = exports.IBoundaryDefinitionSchema = exports.IBoundaryDefinitionSchema_ConnectionDefinition = exports.IBoundaryDefinitionSchema_NumericalDefinition = void 0;
const zod_1 = require("zod");
const IConnectionBoundaryDefinition_1 = require("./IConnectionBoundaryDefinition");
const INumericalBoundaryDefinition_1 = require("./INumericalBoundaryDefinition");
const IBoundaryBase_1 = require("./IBoundaryBase");
exports.IBoundaryDefinitionSchema_NumericalDefinition = INumericalBoundaryDefinition_1.INumericalBoundaryDefinitionSchema.merge(IBoundaryBase_1.IBoundaryBaseSchema);
exports.IBoundaryDefinitionSchema_ConnectionDefinition = IConnectionBoundaryDefinition_1.IConnectionBoundaryDefinitionSchema.merge(IBoundaryBase_1.IBoundaryBaseSchema);
exports.IBoundaryDefinitionSchema = zod_1.z.discriminatedUnion('type', [
    exports.IBoundaryDefinitionSchema_NumericalDefinition,
    exports.IBoundaryDefinitionSchema_ConnectionDefinition,
]);
exports.IBoundaryDefinitionWithIdSchema_NumericalDefinition = INumericalBoundaryDefinition_1.INumericalBoundaryDefinitionSchema.merge(IBoundaryBase_1.IBoundaryBaseSchema).extend({
    boundaryId: zod_1.z.string(),
    boundaryGlobalId: zod_1.z.string(),
});
exports.IBoundaryDefinitionWithIdSchema_ConnectionDefinition = IConnectionBoundaryDefinition_1.IConnectionBoundaryDefinitionSchema.merge(IBoundaryBase_1.IBoundaryBaseSchema).extend({
    boundaryId: zod_1.z.string(),
    boundaryGlobalId: zod_1.z.string(),
});
exports.IBoundaryDefinitionWithIdSchema = zod_1.z.discriminatedUnion('type', [
    exports.IBoundaryDefinitionWithIdSchema_NumericalDefinition,
    exports.IBoundaryDefinitionWithIdSchema_ConnectionDefinition,
]);
//# sourceMappingURL=IBoundaryDefinition.js.map